import { useTheme } from "styled-components";
import { useLanguageContext } from "../../context/LanguageContext";
import { StyledAltButton, StyledButton } from "../../styles/ButtonStyles";
import {
  StyledCard,
  StyledCardBody,
  StyledCardHeader,
} from "../../styles/CardStyles";
import { StyledFlexRow } from "../../styles/LayoutStyles";
import HiddenLoader from "../loader/HiddenLoader/HiddenLoader";
import EVAApiHelper from "../../helpers/EVAApiHelper";
import { StyledInputError } from "../input/wrapper/InputWrapperStyles";
import Form from "../form/Form";

function FormContainerView({
  header,
  children,
  onCancel,
  onSubmit,
  submitError,
  submitLoadingGroup,
  actions,
  formId,
}) {
  const theme = useTheme();
  const { translate } = useLanguageContext();

  //Render the card as a form when it can be submitted, so enter submits it
  //The form id lets inputs outside the card (form="<formId>") submit it as well
  const formProps = onSubmit
    ? { as: Form, id: formId, onSubmit, loadingGroups: submitLoadingGroup }
    : {};

  return (
    <StyledCard {...formProps}>
      <StyledCardHeader>
        {!header || typeof header === "string" ? (
          <h2>{header ?? translate("eva.main.general.data")}</h2>
        ) : (
          header
        )}
      </StyledCardHeader>

      <StyledCardBody>
        {children}

        {onSubmit || onCancel || actions ? (
          <StyledFlexRow style={{ margin: `${theme.spacing.large} 0px 0px` }}>
            {onCancel ? (
              <StyledAltButton onClick={onCancel}>
                {translate("eva.main.general.cancel")}
              </StyledAltButton>
            ) : (
              ""
            )}

            {actions}

            {onSubmit ? (
              <HiddenLoader groups={submitLoadingGroup}>
                <StyledButton type="submit">
                  {translate("eva.main.general.save")}
                </StyledButton>
              </HiddenLoader>
            ) : (
              ""
            )}
          </StyledFlexRow>
        ) : (
          ""
        )}

        <StyledInputError>
          {EVAApiHelper.getResponseError("message", submitError)}
        </StyledInputError>
      </StyledCardBody>
    </StyledCard>
  );
}

export default FormContainerView;
